<template>
  <div>
    <el-button type="primary" class="iconShouce" @click="handleCourse">接入教程</el-button>
    <!-- <div class="iconShouce">接入教程</div> -->
    <!-- <img src="../../../assets/images/shouce.png" class="iconShouce" @click="handleCourse"/> -->
    <div class="list">
       <!--一条数据开始-->
       <template v-if="list.length">
         <div class="listItem" v-for="item in list" :key="item.id">
           <div class="pageTitle">
                <span class="name">{{item.title}}</span>
                <template v-if="item.approveStatus === 0">
                  <span class="status status0">审核中</span>
                </template>
                <template v-if="item.approveStatus === 1">
                  <span class="status status1">通过</span>
                </template>
                <template v-if="item.approveStatus === 2">
                  <span class="status status2">不通过</span>
                </template>
                <template v-if="item.approveStatus === 3">
                  <span class="status status3">禁用</span>
                </template>
                <div class="handleBox">
                  <span class="editBtn" @click="handleEditApp(item)"><img src="../../../assets/images/appEdit.png" />编辑</span>
                  <span class="delBtn"  @click="handleDeleteApp(item)"><img src="../../../assets/images/appDelete.png" />删除</span>
                </div>
                <template v-if="item.approveStatus == 1">
                  <div class="btn">
                    <a :href="item.loginUrl ? item.loginUrl : ''" target="_blank">
                    <div>跳转应用</div>
                    <img src="../../../assets/images/rightArrow.png" alt="">
                    </a>
                  </div>
                  <div class="btn btn1" style="bottom: 70px;position: absolute;" @click="handleRegister(item)">
                    <div>同步账号</div>
                  </div>
                </template>
           </div>
           <div class="pageContent">
                <div>
                  <span class="label">应用回调地址</span>
                  <span>{{item.linkUrl}}</span>
                </div>
                <div>
                  <span class="label">用户同步地址</span>
                  <span>{{item.registerUrl}}</span>
                </div>
                <div>
                  <span class="label">创建时间</span>
                  <span>{{item.createTime}}</span>
                </div>
            </div>
            <div class="pageContent">
                <div>
                  <span class="label">客户端名称</span>
                  <span>{{item.clientName}}</span>
                </div>
                <div>
                  <span class="label">clientId</span>
                  <span>{{item.clientId}}</span>
                </div>
                <div>
                  <span class="label">clientSecret</span>
                  <span>{{item.clientSecret}}</span>
                </div>
            </div>
           <div class="pageContent">
             <div v-if="item.approveTime">
               <span class="label">审核时间</span>
               <span>{{item.approveTime}}</span>
             </div>
             <div v-if="item.approveTime">
               <span class="label">审核原因</span>
               <span>{{item.reason}}</span>
             </div>
           </div>
           <div class="pageContent">
                <div class="ts">
                  <span class="label">应用描述</span>
                  <span>{{item.describe}}</span>
                </div>
             </div>

       </div>
       </template>
       <template v-else>
         <Nodata />
       </template>

    </div>
    <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageNum"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next"
    :total="total">
    </el-pagination>
    <!--编辑弹窗-->
    <AppDialog ref="appDialog2" @closeAppDialog="closeAppDialog" />
    <!--同步应用-->
    <RegisterDialog ref="registerDialog" @refresh="refresh" />
    <!--教程弹窗-->
    <CourseDialog ref="courseDialog" />
  </div>
</template>
<script>
import { fetchManageAppList, fetchDeleteApp} from '@/api/api'
import Nodata from '@/components/noData.vue'
import AppDialog from './AppDialog.vue'
import RegisterDialog from './RegisterDialog'
import CourseDialog from './CourseDialog.vue'
export default {
    data() {
      return {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        list: [],
        loading: false,
      }
    },
    mounted() {
        this.getList()
    },
    components:{
      AppDialog,
      Nodata,
      RegisterDialog,
      CourseDialog
    },
    methods:{
      handleCourse() {
        this.$refs.courseDialog.openDialog()
      },
      handleRegister(item) {
        let data = {
          type: 2,
          applicationId: item.id
        }
        this.$refs.registerDialog.openDialog(data)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      closeAppDialog() {
        this.refresh()
      },
      refresh() {
        this.pageNum = 1
        this.getList()
      },
      handleEditApp(data) {
        this.$refs.appDialog2.openDialog(data)
      },
      handleDeleteApp(item) {
        let params={
          id: item.id
        }
        fetchDeleteApp(params).then(res => {
          if(res.code == 1) {
            this.$message.success('删除成功');
            this.getList()
          }else {
            this.$message.error('删除失败');
          }
        })
      },
      getList() {
        let params = {
          page: this.pageNum - 1,
          size: this.pageSize
        }
        fetchManageAppList(params).then(res => {
          this.list = res.data.content
          this.total = Number(res.data.totalElements)
        })
      }
    }
}
</script>
<style scoped>
  .listItem {
    padding: 10px 0;
    border-bottom: 1px solid #E8EBF4;
    position: relative;
    position: relative;
  }

  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    margin-left: 10px;
  }
  .status0{

  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: rgba(255,111,5,0.1);
    color: #FF8D3A;
    border: 1px solid #FF8D3A;
  }
  .status3{
    background:#fff;
    color: #ccc;
    border: 1px solid #ccc;
  }

  .pageTitle {
    padding: 15px 0;
  }

  .pageContent {
    padding: 15px 0 0;
    display: flex;
    justify-content: flex-start;
  }

  .pageContent > div {
    width: 30%;
  }
  .pageContent > div.ts{
      width: 85%;
  }
  .pageContent .label{
      color: rgba(144, 157, 177, 1);
      padding-right: 20px;
      min-width: 80px;
      padding-right: 20px;
  }

  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .list{
    height: calc(100vh - 280px);
    overflow-y: scroll;
    width: 100%;
    /* border: 1PX SOLID #F00; */
  }
  .list::-webkit-scrollbar { width: 0 !important }

      .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0px;
    bottom: 10px;
    cursor: pointer;

  }
  .btn1 {
    border: 1px solid #299200;
  }

  .btn1 > div {
    color: #299200 !important;
  }
  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
    /* width: 18px;
    height: 9px; */
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
  }

  .el-pagination{
      display: flex;
      justify-content: flex-end;
  }
  .handleBox{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    float: right;
    vertical-align: middle;
  }
  .handleBox span:nth-child(1){
    margin-right: 30px;
  }
  .handleBox img{
    width: 16px;
    height: 16px;
    margin-right: 5px;
    vertical-align: middle;
  }
  .handleBox .editBtn {
    color: rgba(241, 170, 0, 1);
    cursor: pointer;
    vertical-align: middle;
  }
  .handleBox .delBtn {
    color: rgba(18, 30, 48, 1);
    cursor: pointer;
    vertical-align: middle;
  }
  .iconShouce{
    /* width: 20px; */
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
    position: absolute;
    right: 50px;
    top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/console/components/ManageApp.vue